import { AxiosRequestConfig } from "axios";
import HTTP, { apiHandler } from "@services/http.service";
import { ServerRequest } from "@lib/shared/types";

interface NearbyZipCodesResponse {
    data: ZipCodeInformation | null;
    error: Error | null;
}

export interface ZipCodeInformation {
    currentZipCode: ZipCode;
    supportedZipCodes: ZipCode[];
}

export type ZipCode = Partial<{
    zipCode: string;
    stateCode: string;
    city: string;
    countryCode: string;
    latitude: number;
    longitude: number;
    county: string;
}>;

export const getNearbyZipCodes = async ({
    req,
    category,
}: {
    req: ServerRequest;
    category: string | undefined;
}): Promise<{ data: ZipCodeInformation | null; error: Error | null }> => {
    const accessToken = req.accessToken;

    if (!category) {
        return {
            data: null,
            error: new Error("Category is required"),
        };
    }

    const config: AxiosRequestConfig = {
        method: "get",
        url: `/api/web/v1/categories/${category}/supported-zipcodes`,
        headers: {
            "X-DOMAIN-NAME": `${req.headers?.host ?? ""}`,
            Authorization: `Bearer ${accessToken as string}`,
            "X-Language": req.locale ?? "en",
        },
    };

    const { data: nearbyZipCodesResponse, error } =
        await apiHandler<NearbyZipCodesResponse>(() => HTTP.server(config));

    return {
        data: nearbyZipCodesResponse?.data ?? null,
        error,
    };
};
